import React from 'react'
import './App.css';
import video from "./video.mp4";

const rules = () => {
  return (
    <>
    <div className='ed'>
      
      <h3 className='ss'>EVENT REGULATION:</h3>
      <table className='table123'>
        
    <tr>
        <th>SI NO</th>
        <th>EVENT</th>
        <th>THEME</th>
        <th>RULES</th>
    </tr>
    <tr>
        <td>1</td>
        <td>PROJECT COMPETITION
For Junior Scientist
(Team Event)
</td>
        <td>1.Agriculture<br></br>
        2.Clean Water and Sanitation<br></br>
        3.Affordable and Clean Energy<br></br>
        4.Innovation<br></br>
        5.Climate Action
        </td>
        <td>1.	Any registered School Student (VI-Xth std.) belonging to State/Matric/CBSE/Other boards studying in any district of TN/Other state of India.<br></br>
2.	Minimum 2 students and Maximum 4 students / team<br></br>
3.	Student Team not necessary to be from the same Standard.<br></br>
4.	Only 5 teams allowed from 1 school in any of the above theme (Based on request number of teams may be increased)
</td>
</tr>
<tr>
    
        <td>2</td>
        <td>PROJECT COMPETITION
For Young Scientist
(Team Event)
</td>
        <td>1.Good Health and Well being<br></br>
        2.Information and Communication Technology for Women Empowerment<br></br>
        3.Smart Industry for Economic Growth<br></br>
        4.Smart Cities and Infrastructure<br></br>
        5.Responsible Consumption and Production
        </td>
        <td>1.	Any registered School Student (XIth std.-XIIth ) belonging to State/Matric/CBSE/Other boards studying in any district of TN/Other state of India.<br></br>
2.	Minimum 2 students and Maximum 4 students / team<br></br>
3.	Only 5 teams allowed from 1 school in any of the above theme (Based on request number of teams may be increased)
</td>
    </tr>
    <tr>
        <td>3</td>
        <td>SDG Treasure Hunt
(Team Event)
</td>
        <td><center>--</center></td>
        <td>1.	Only registered school student from VI-XII can participate<br></br>
2.	Student should follow the campus map to identify and locate the treasure<br></br>
3.	Min. 10 students from each school is allowed to participate
</td>
    </tr>
    <tr>
        <td>4</td>
        <td>ROBO COMPETITION
(Team Event)
</td>
        <td>1.Line Follower<br></br>
        2.Maze Follower<br></br>
        3.All Terrain Robot
        </td>
        <td>1.	Any registered School Student (VIth std.-XIIth ) belonging to State/Matric/CBSE/Other boards studying in any district of TN/Other state of India.<br></br>
2.	Minimum 2 students and Maximum 3 students / team
</td>
    </tr>
    
    <tr>
        <td>5</td>
        <td>PHOTOGRAPHY CONTEST ALIGN WITH SDG
(Individual Event)
</td>
        <td>1.No Poverty<br></br>
        2.Life below Water<br></br>
        3.Life on Land<br></br> 
        4.Reduced Inequalities<br></br>
        5.Peace and Justice
        </td>
        
        <td>1.	GeoTagged Photo along with the description of not less than100 words.<br></br>
2.	Min. 5 students from each school is allowed to participate
</td>
    </tr>
    <tr>
        <td>6</td>
        <td>INNOVATIVE DRONE CONTEST
(Team Event)

</td>
        <td><center>--</center></td>
        <td>1.	Only 1 team is allowed from each school (Based on request number of teams may be increased)</td>
    </tr>
</table>
    </div><br></br>
    <div className='gr' >
      <h2>
        General Rules:
      </h2>
      <ul>
<li>Buses will be provided for schools registering for a minimum of 50 students individually and if a minimum of 20 students registered will be combined with nearby schools</li>
<li>Evaluation by External jury members is final</li>
<li>The Event timing are from 9.00 am to 4.00 pm</li>
<li>Breakfast and Lunch are provided to all students</li>

      </ul>

    </div>
    <br/>
    {/* <div>
    <center>
    <video className="video" src={video} type="video/mp4" controls></video>
    </center>
    </div> */}
    <br/>
    </>  
  )
}

export default rules